import React, { useState } from "react"

// styled components
import {
  ItemContainer,
  ImageContainer,
  UpperImageTools,
  FarAway,
  Like,
  LocationText,
  BottomContainer,
  FeaturesContainer,
  PriceContainer,
} from "./ListingsCarouselItem.styles"

import { Link } from "gatsby"

import LocationDrop from "../../assets/icons/location-drop.svg"
import { arrayRemove, arrayUnion, doc, updateDoc } from "firebase/firestore"
import { db } from "../../firebase/config"

function ListingsCarouselItem({
  listing,
  location,
  isLiked,
  user,
  userId,
  arabic,
}) {
  // handling the press of the like button it will push or take away from the array of liked properties in the user
  const handleLike = id => {
    if (user) {
      const docRef = doc(db, "users", user.uid)
      if (isLiked) {
        updateDoc(docRef, {
          liked_properties: arrayRemove(id),
        })
      } else {
        updateDoc(docRef, {
          liked_properties: arrayUnion(id),
        })
      }
    } else {
      alert("Please login first in order to be able to favorite the listings")
    }
  }

  const data = listing.data

  const [away, setAway] = useState("")

  // caculating distance between two positions
  const calcDist = (lat1, lon1, lat2, lon2, unit) => {
    if (lat1 === lat2 && lon1 === lon2) {
      return 0
    } else {
      var radlat1 = (Math.PI * lat1) / 180
      var radlat2 = (Math.PI * lat2) / 180
      var theta = lon1 - lon2
      var radtheta = (Math.PI * theta) / 180
      var dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
      if (dist > 1) {
        dist = 1
      }
      dist = Math.acos(dist)
      dist = (dist * 180) / Math.PI
      dist = dist * 60 * 1.1515
      if (unit === "K") {
        dist = dist * 1.609344
      }
      if (unit === "N") {
        dist = dist * 0.8684
      }
      return dist
    }
  }

  // checking if data exists and calculating accordingly
  if (data && data.longitude && data.latitude && location) {
    location.getCurrentPosition(
      position => {
        setAway(
          parseInt(
            calcDist(
              parseFloat(data.latitude),
              parseFloat(data.longitude),
              position.coords.latitude,
              position.coords.longitude,
              "K"
            )
          )
        )
      },
      error => {}
    )
  }
  return (
    <ItemContainer className="listing">
      <Link to={`/property/${listing.id}`}>
        <ImageContainer>
          {data && data.featured_image && (
            <img
              src={
                data.featured_image.url === " "
                  ? "https://firebasestorage.googleapis.com/v0/b/opddev-51cfb.appspot.com/o/images%2Fproperty%2Fthumbnail%2Fb4.jpg-f73c7baa-197b-4b91-9f6e-b65c4be682b6?alt=media&token=c389edb7-7fec-4fad-a0c9-e4c1bc71fb80"
                  : data.featured_image.url
              }
              className="image"
              alt="listing"
            />
          )}
          <UpperImageTools locationExists={away ? true : false}>
            {away && <FarAway>{away} km Away</FarAway>}
            <Like onClick={() => handleLike(listing.id)} isLiked={isLiked}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25.598"
                height="23.743"
                viewBox="0 0 25.598 23.743"
              >
                <path
                  id="Icon_material-favorite"
                  data-name="Icon material-favorite"
                  d="M15.3,27.068l-1.783-1.623C7.182,19.7,3,15.913,3,11.264A6.7,6.7,0,0,1,9.764,4.5,7.365,7.365,0,0,1,15.3,7.07,7.365,7.365,0,0,1,20.833,4.5,6.7,6.7,0,0,1,27.6,11.264c0,4.649-4.182,8.437-10.516,14.193Z"
                  transform="translate(-2.5 -4)"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="1"
                />
              </svg>
            </Like>
          </UpperImageTools>
        </ImageContainer>
        <Link to={`/property/${listing.id}`}>
          <h4>{data && data.title}</h4>
        </Link>
        <LocationText>
          <img src={LocationDrop} alt="Location drop icon" />
          <p>
            {(data && data.address) || (data && data.street_name)},
            {data && data.country.label}
          </p>
          {data && data.sale_price && data.rent_price && (
            <PriceContainer>
              {data.sale_price.toLocaleString("en-US")} USD
            </PriceContainer>
          )}
          {data && data.sale_price && !data.rent_price && (
            <PriceContainer>
              {data.sale_price.toLocaleString("en-US")} USD
            </PriceContainer>
          )}
          {data && data.rent_price && !data.sale_price && (
            <PriceContainer>
              {data.rent_price.toLocaleString("en-US")} USD/m
            </PriceContainer>
          )}
        </LocationText>
        <BottomContainer>
          {data && data.num_bathrooms > 0 && (
            <FeaturesContainer>
              {data && data.num_bedrooms} 
              <svg fill="#000000" width="32px" height="32px" viewBox="0 0 512 512" enable-background="new 0 0 512 512"  version="1.1"  xmlns="http://www.w3.org/2000/svg" ><path d="M457.106,274.303c0.703-1.426,1.11-3.022,1.11-4.717V253.92c0-10.756-8.752-19.507-19.509-19.507  h-12.86v-87.491c0-15.948-12.974-28.922-28.922-28.922H115.878c-15.948,0-28.922,12.975-28.922,28.922v87.491H73.279  c-10.757,0-19.508,8.751-19.508,19.507v15.666c0,1.695,0.407,3.294,1.112,4.72C40.106,278.307,29.2,291.826,29.2,307.852v46.687  c0,8.568,6.97,15.539,15.539,15.539h32.245v14.557c0,5.165,4.202,9.366,9.367,9.366h8.399c5.165,0,9.367-4.201,9.367-9.366v-14.557  h314.527v14.557c0,5.165,4.202,9.366,9.367,9.366h8.399c5.165,0,9.367-4.201,9.367-9.366v-14.557h21.481  c8.569,0,15.539-6.971,15.539-15.539v-46.687C482.8,291.822,471.889,278.3,457.106,274.303z M94.156,146.922  c0-11.978,9.744-21.722,21.722-21.722h281.048c11.979,0,21.723,9.745,21.723,21.722v86.574h-42.646v-9.549  c0-5.765-4.689-10.455-10.455-10.455h-75.09c-5.765,0-10.455,4.69-10.455,10.455v9.549h-47.2v-9.549  c0-5.765-4.69-10.455-10.454-10.455h-75.091c-5.766,0-10.455,4.69-10.455,10.455v9.549H94.156V146.922z M368.803,223.947v9.549  h-81.601v-9.549c0-1.794,1.46-3.255,3.255-3.255h75.09C367.342,220.692,368.803,222.153,368.803,223.947z M225.602,223.947v9.549  h-81.6v-9.549c0-1.794,1.46-3.255,3.255-3.255h75.091C224.142,220.692,225.602,222.153,225.602,223.947z M60.972,253.92  c0-6.786,5.521-12.307,12.308-12.307h365.429c6.786,0,12.309,5.521,12.309,12.307v15.666c0,1.931-1.57,3.502-3.502,3.502H64.474  c-1.932,0-3.502-1.571-3.502-3.502V253.92z M96.918,384.634c0,1.194-0.972,2.166-2.167,2.166h-8.399  c-1.195,0-2.167-0.972-2.167-2.166v-13.913h12.733V384.634z M438.579,384.634c0,1.194-0.972,2.166-2.167,2.166h-8.399  c-1.195,0-2.167-0.972-2.167-2.166v-13.913h12.733V384.634z M475.6,354.538c0,4.599-3.74,8.339-8.339,8.339H44.739  c-4.599,0-8.339-3.74-8.339-8.339v-46.687c0-15.193,12.36-27.555,27.555-27.555h37.282h309.525h37.281  c15.195,0,27.556,12.361,27.556,27.555V354.538z" /></svg>  {data && data.num_bathrooms}{" "}
              <svg fill="#000000" width="32px" height="32px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" id="bathtub" version="1.1"  xmlns="http://www.w3.org/2000/svg">

<g id="bathtub_1_">

<path d="M440.908,266.62h-3.936V135.815l-0.061-3.601h-0.236c-3.348-36.628-33.963-64.836-71.152-64.836   c-28.881,0-55.197,17.775-66.117,44.426c-4.104,0.084-8.193,0.95-12.082,2.607c-7.99,3.405-14.176,9.718-17.42,17.78l-0.178,0.444   c-0.938,2.329-0.912,4.885,0.072,7.194c0.984,2.311,2.809,4.099,5.139,5.036l42.889,17.257c1.145,0.461,2.33,0.679,3.494,0.679   c3.727,0,7.262-2.229,8.736-5.895l0.18-0.446c3.242-8.058,3.152-16.896-0.254-24.885c-1.527-3.587-3.646-6.807-6.242-9.563   c6.832-16.972,23.363-28.235,41.783-28.235c24.84,0,45.049,20.208,45.049,45.048V266.62H201.26   c-1.885-3.537-5.608-5.952-9.889-5.952h-49.6c-4.279,0-8.002,2.415-9.887,5.952h-60.78c-3.631,0-7.055,1.415-9.649,3.993   c-2.575,2.576-3.995,5.998-3.995,9.639c0,7.517,6.121,13.633,13.645,13.633h9.601v118.367c0,9.138,7.438,16.572,16.583,16.572   h13.284v9.994c0,3.199,2.603,5.803,5.802,5.803h11.391c3.199,0,5.802-2.604,5.802-5.803v-9.994h252.205v9.994   c0,3.199,2.604,5.803,5.803,5.803h11.391c3.199,0,5.803-2.604,5.803-5.803v-9.994h11.775c9.145,0,16.586-7.435,16.586-16.572   V293.885h3.779c3.639,0,7.061-1.42,9.639-3.996c2.574-2.574,3.992-5.997,3.992-9.637   C454.539,272.735,448.426,266.62,440.908,266.62z M323.555,153.778l-0.18,0.445c-0.451,1.125-1.74,1.672-2.861,1.221   l-42.889-17.257c-0.545-0.219-0.973-0.638-1.203-1.179c-0.229-0.54-0.236-1.138-0.014-1.688l0.178-0.445   c5.211-12.95,19.99-19.247,32.934-14.035c6.273,2.523,11.189,7.339,13.84,13.561C326.01,140.62,326.08,147.501,323.555,153.778z    M365.523,86.579c-20.576,0-39.119,12.121-47.539,30.601c-1.801-1.183-3.73-2.197-5.775-3.02c-1.73-0.696-3.498-1.229-5.283-1.619   c10.291-22.856,33.354-37.962,58.598-37.962c34.482,0,62.678,26.968,64.193,61.395l0.055,0.917v129.725h-12V138.827   C417.771,110.018,394.334,86.579,365.523,86.579z M137.773,271.868c0-2.206,1.794-4,3.999-4h49.6c2.206,0,4.001,1.794,4.001,4   v83.899h-57.6V271.868z M137.773,362.968h57.6v3.9c0,2.205-1.795,4-4.001,4h-49.6c-2.205,0-3.999-1.795-3.999-4V362.968z    M80.706,286.684h-9.601c-3.553,0-6.444-2.885-6.444-6.432c0-1.717,0.67-3.33,1.879-4.538c1.229-1.222,2.85-1.894,4.565-1.894   h59.468v12.863H80.706z M130.573,293.885v29.783H87.905v-29.783H130.573z M126.367,437.42h-8.595v-8.595h8.595V437.42z    M401.568,437.42h-8.596v-8.595h8.596V437.42z M429.928,412.252c0,5.168-4.209,9.372-9.385,9.372H97.289   c-5.174,0-9.384-4.204-9.384-9.372v-81.384h42.668v36c0,6.176,5.024,11.2,11.199,11.2h49.6c6.177,0,11.201-5.024,11.201-11.2v-36   h227.355V412.252z M429.928,323.668H202.573v-29.783h227.355V323.668z M445.455,284.798c-1.215,1.217-2.83,1.886-4.547,1.886   h-3.779H202.573V273.82h238.335c3.547,0,6.432,2.885,6.432,6.432C447.34,281.969,446.67,283.582,445.455,284.798z"/>

<rect height="43.701" transform="matrix(-0.9314 -0.364 0.364 -0.9314 477.8781 464.6737)" width="7.199" x="279.122" y="165.46"/>

<rect height="33.5" transform="matrix(0.9314 0.3639 -0.3639 0.9314 90.9336 -95.4659)" width="7.201" x="295.235" y="176.856"/>

<rect height="33.5" transform="matrix(-0.9314 -0.364 0.364 -0.9314 449.2144 446.7517)" width="7.199" x="263.102" y="164.3"/>

</g>

</svg>  {data && data.area}
              {arabic === false ? (
                <>
                  m<sup>2</sup>
                  </>
              ) : (
                " مترًا مربعًا"
              )}
            </FeaturesContainer>
          )}
          
        </BottomContainer>
      </Link>
    </ItemContainer>
  )
}

export default ListingsCarouselItem
